module.exports = __webpack_public_path__ + "static/img/brand-second-2.e95df7cb.png";